import axiosInstance from "../api/axiosInstance"

// GET: List users with pagination, filters, search
export const fetchclub = (params) => axiosInstance.get("/admin/eventList", { params });

// GET: Get single user details by ID
export const getClubDetail = (id) => axiosInstance.get(`/admin/eventGet/${id}`);
// PATCH: Ban or unban user
export const changeClubStatus = (id, data) => axiosInstance.patch(`/admin/eventChangeStatus/${id}`, data);

export const changeClubFeature = (id,data) => axiosInstance.patch(`/admin/eventChangeFeature/${id}`, data);

export const changeGratuityFeature = (id,data) => axiosInstance.patch(`/admin/eventChangeGratuity/${id}`, data);

